import type { Experiment, Result } from '@growthbook/growthbook-react';
import {
  HOME_TOP_10,
  SEARCH_CERTIFICATE
} from 'components/Integration/constantsLabel';
import addEventToDataLayer from 'components/Integration/addEventToDataLayer';
import { Experiments } from 'constants/enums/experiment';

export function handleExperimentEvent({
  experiment,
  result
}: {
  experiment: Experiment<unknown>;
  result: Result<{ label: string }>;
}) {
  switch (experiment.key) {
    case Experiments.SEARCH_CERTIFICATE:
      addEventToDataLayer({
        category: 'consumerTestAB',
        label: result?.value
          ? SEARCH_CERTIFICATE.longSentence
          : SEARCH_CERTIFICATE.shortSentence,
        action: 'view'
      });
      break;
    case Experiments.ALGOLIA_SEARCH_BAR:
      window?.dataLayer?.push({
        category: 'searchTestAB',
        growthbook_search_test_ab_label: result?.value ? 'B' : 'A',
        action: 'view'
      });
      break;
    case Experiments.DISCOVERY_HOME_TOP_10:
      addEventToDataLayer({
        category: 'consumerTestAB',
        label: result?.value
          ? HOME_TOP_10.showMatrix
          : HOME_TOP_10.noShowMatrix,
        action: 'view'
      });
      break;

    default:
      break;
  }
}
